import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CrmEvents } from '../../../features/crm/components/crm-events';
import { crmCitiesOptions } from '../../../features/crm/queries';

export const Route = createFileRoute('/_authenticated/crm/events')({
  staticData: { breadcrumb: 'Ивенты' },
  validateSearch: z.object({ cityId: z.uuid().optional() }),
  component: EventsPage,
});
function EventsPage() {
  const { cityId } = Route.useSearch();
  const { data: cities } = useSuspenseQuery(crmCitiesOptions());
  return (
    <div className="min-w-0 space-y-4">
      <CrmEvents key={cityId ?? 'all'} {...(cityId ? { cityId } : {})} cities={cities} />
    </div>
  );
}
